module.exports = __webpack_public_path__ + "img/circle-gray.4fbefa45.svg";